module.exports = {
	"units": {
		"hy": {
			"locX": 280,
			"locY": 390,
			"radius": 250,
			"colors": {
				"primary": "rgba(71,150,209,1)",
				"secondary": "rgba(71,150,209,0.3)",
				"hidden": "rgba(71,150,209,0.3)"
			}
		},
		"el": {
			"locX": 600,
			"locY": 390,
			"radius": 70,
			"colors": {
				"primary": "rgba(71,150,209,1)",
				"secondary": "rgba(71,150,209,0.3)",
				"hidden": "rgba(71,150,209,0.3)"
			}
		},
		"fc": {
			"locX": 280,
			"locY": 710,
			"radius": 70,
			"colors": {
				"primary": "rgba(71,150,209,1)",
				"secondary": "rgba(71,150,209,0.3)",
				"hidden": "rgba(71,150,209,0.3)"
			}
		},
		"pv": {
			"locX": 1050,
			"locY": 300,
			"radius": 110,
			"colors": {
				"primary": "rgba(248,231,28,1)",
				"secondary": "rgba(248,231,28,0)",
				"hidden": "rgba(248,231,28,0.3)"
			}
		},
		"ld": {
			"locX": 780,
			"locY": 610,
			"radius": 125,
			"colors": {
				"primary": "rgba(80,227,141,1)",
				"secondary": "rgba(80,227,141,0)",
				"hidden": "rgba(80,227,141,0.3)"
			}
		},
		"bt": {
			"locX": 1070,
			"locY": 800,
			"radius": 80,
			"colors": {
				"primary": "rgba(254,171,19,1)",
				"secondary": "rgba(254,171,19,0.3)",
				"hidden": "rgba(254,171,19,0.3)"
			}
		},
		"ht": {
			"locX": 630,
			"locY": 990,
			"radius": 90,
			"colors": {
				"primary": "rgba(249,99,50,1)",
				"secondary": "rgba(249,99,50,0)",
				"hidden": "rgba(249,99,50,0.3)"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/bubbles.json
// module id = ./src/config/bubbles.json
// module chunks = 0